import React from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import style from "../../assets/css/components/Form/Form.module.css";

import { Formik, Form } from "formik";
import Button from "../Button/Button";

import Input from "../Input/Input";
import InputSelect from "../Input/InputSelect";
import {
  AddMatchInitialState,
  AddMatchValidationSchema,
} from "../../utils/match";
import useAddMatch from "../../hooks/useAddMatch";
import classNames from "classnames";
import dayjs from "dayjs";

const MySwal = withReactContent(Swal);

const optionsType = [
  { value: "amistoso", label: "Amistoso" },
  { value: "jornada", label: "Jornada" },
  { value: "repechaje", label: "Repechaje" },
  { value: "cf", label: "Cuartos de final" },
  { value: "semifinal", label: "Semifinal" },
  { value: "final", label: "Final" },
];

function FormAddMatch({ options }) {
  const { loading, addMatch } = useAddMatch();

  if (loading) return <p style={{ color: "papayawhip" }}>Cargando...</p>;

  const handleSubmit = async (values) => {
    // values = {
    //   ...values,
    //   status: "0",
    // };
    values = {
      ...values,
      day: values.type !== "jornada" ? 0 : values.day,
      hour: dayjs(values.date + " " + values.hour).format("HH:mm:ss"),
    };
    console.log(values);
    const response = await addMatch(values);
    MySwal.fire(response);
  };

  return (
    <Formik
      initialValues={AddMatchInitialState}
      validationSchema={AddMatchValidationSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, handleChange, touched, values }) => {
        // const { errors, handleChange, touched } = props;
        return (
          <Form className={style.form}>
            <div className={classNames(style.formColumn, style.threeColumn)}>
              <InputSelect
                error={touched.local && errors.local}
                name="local"
                title="Equipo local"
                options={options}
                onChange={(selectedOption) => {
                  handleChange("local")(selectedOption.value);
                }}
              />
              <InputSelect
                error={touched.visit && errors.visit}
                name="visit"
                title="Equipo visita"
                options={options}
                onChange={(selectedOption) => {
                  handleChange("visit")(selectedOption.value);
                }}
              />
              <InputSelect
                error={touched.type && errors.type}
                name="type"
                title="Tipo de partido"
                options={optionsType}
                onChange={(selectedOption) => {
                  handleChange("type")(selectedOption.value);
                }}
              />
              {values.type === "jornada" ? (
                <Input name="day" title="Jornada" type="number" />
              ) : null}
              <Input name="date" title="Fecha" type="date" />
              <Input name="hour" title="Hora" type="time" />
            </div>
            <Button text="Guardar" />
          </Form>
        );
      }}
    </Formik>
  );
}

export default FormAddMatch;
